import React, { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import { ButtonGraph } from '../../../components/button-graph';
import { PanelContent } from '../../../components/panel-content';
import { useStateValue } from '../../../components/state';
import { Button } from '../../../components/button';
import { facts } from './facts';
import { FactGroup } from '../../../components/fact-group';

export const WhereHome: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue();

  // Filter map pins to all
  useEffect(() => {
    dispatch({ type: 'setActiveMarkerType', payload: { activeMarkerType: 'all' } });
  }, [dispatch]);

  return (
    <PanelContent>
      <h1>Where does Perth's drinking water come from?</h1>
      <ButtonGraph href="desalination" title="Desalination" percentage={38} color="pink" icon="desalination" />
      <ButtonGraph href="groundwater" title="Groundwater" percentage={34} color="green" icon="groundWater" />
      <ButtonGraph href="dams" title="Dams" percentage={22} color="blue" icon="dam" />
      <ButtonGraph
        href="groundwater-replenishment"
        title="Groundwater replenishment"
        color="orange"
        percentage={6}
        icon="groundWaterReplenishment"
      />
      <FactGroup data={facts} />
      <Button href="/why">See how our sources have changed over time</Button>
    </PanelContent>
  );
};
